import React, { useEffect } from "react";
import "../popup.css";
import SubmitButton from "../../Buttons/SubmitButton";
import CancelButton from "../../Buttons/CancelButton";
import ExternalLink from "../../ExternalLink/ExternalLink.tsx";
import { gtmPush } from "../../../analytics/useGtmPageview.tsx";

const AgeWarningModal = ({ onContinue, onCancel, onClose, extraLine = "" }) => {
  useEffect(() => {
    gtmPush("popup_open", {
      popup_id: "age_warning",
      popup_name: "Age is under 13",
      trigger: "auto",
      page_path: window.location.pathname + window.location.search,
    });
  }, []);

  const handleOverlayClick = (e) => {
    // Only trigger cancel if user clicks directly on the overlay
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <h1 className="modal-title">
          The age you've entered means
          <br />
          you may not need a verified identity
        </h1>

        <p className="modal-text">
          Applicants aged 13 years and under may not need a verified identity.
          This is because there are not many services that someone this age
          would need to access.
        </p>

        <p className="modal-text">
          <ExternalLink
            href="https://www.passports.govt.nz"
            text="apply for your passport"
          />
        </p>

        <div className="modal-text">
          If you still want a verified identity, you'll need to:
          <ol className="modal-list">
            <li>continue this application online, then</li>
            <li>
              go to a RealMe partner store with your parent or legal guardian.
            </li>
          </ol>
        </div>
        {extraLine && <p className="modal-text">{extraLine}</p>}

        <div className="modal-actions">
          <SubmitButton text={"Continue"} onClick={onContinue} />
          <CancelButton text={"Cancel application"} onClick={onCancel} />
        </div>
      </div>
    </div>
  );
};

export default AgeWarningModal;
